module.exports = {
  BUGSNAG_API_KEY: '878e575f1e4c629411c14d09b7b26f8f',
  GOOGLE_TAGJS_ID: 'UA-134333990-1',
}
